<template>
    <div class="grid">
        <div class="col-12">
            <div class="card sebrae-painel">
                <header class="sebrae-painel__header">
                    <div class="sebrae-painel__main">
                        <i
                            v-if="icone && icone.includes('pi-')"
                            :class="[icone, 'sebrae-painel__icon']"
                            aria-hidden="true"
                        />
                        <font-awesome-icon
                            v-else-if="icone"
                            :icon="icone"
                            class="sebrae-painel__icon sebrae-painel__icon-fa"
                            aria-hidden="true"
                        />
                        <h1 class="sebrae-painel__title">{{ titulo }}</h1>
                    </div>

                    <div v-if="mostrarRefresh && refreshFunction" class="sebrae-painel__actions">
                        <SebraeButton
                            icon="pi pi-refresh"
                            variant="text"
                            title="Atualizar"
                            aria-label="Atualizar"
                            :loading="refreshing"
                            @click="onRefresh"
                        />
                    </div>
                </header>

                <div class="sebrae-painel__body">
                    <slot />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        titulo: {
            type: String,
            default: () => 'A DEFINIR',
        },

        icone: {
            type: String,
            default: () => null,
        },

        refreshFunction: {
            type: Function,
            default: () => null,
        },

        mostrarRefresh: {
            type: Boolean,
            default: () => true,
        },
    },

    data() {
        return {
            refreshing: false,
        };
    },

    methods: {
        async onRefresh() {
            if (!this.refreshFunction || this.refreshing) {
                return;
            }

            this.refreshing = true;

            try {
                const result = this.refreshFunction();
                if (result?.then) {
                    await result;
                }
            } finally {
                this.refreshing = false;
            }
        },
    },
};
</script>

<style scoped>
.sebrae-painel__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: var(--sebrae-space-4);
    margin-bottom: var(--sebrae-space-5);
}

.sebrae-painel__main {
    display: flex;
    align-items: flex-start;
    gap: var(--sebrae-space-3);
    min-width: 0;
    flex: 1;
}

.sebrae-painel__icon {
    font-size: 1.5rem;
    color: var(--sebrae-primary);
    margin-top: 0.2rem;
    flex-shrink: 0;
    line-height: 1;
}

.sebrae-painel__icon-fa {
    font-family: inherit !important;
    text-transform: none;
}

.sebrae-painel__title {
    margin: 0;
    font-family: var(--sebrae-font-family-base);
    font-size: var(--sebrae-font-size-page-title);
    font-weight: var(--sebrae-font-weight-semibold);
    color: var(--sebrae-text-heading);
    line-height: var(--sebrae-line-height-tight);
    word-break: break-word;
}

.sebrae-painel__actions {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.sebrae-painel__body {
    min-width: 0;
}
</style>